import Recat, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Tooltip, message, Spin, Table } from 'antd'
import { SGeneralForms, SModalSelected } from 'shj-components'
import { httpDictServTenant, getEnum, transferListByRequest, findResponseListByPage } from "@/services/fmsServices";
export const TransFerForm = Recat.forwardRef((props: any, ref) => {
  const { editData } = props
  const formRef: any = useRef()
  const [spinning, setSpinning] = useState(false)
  const [disabledState, setDisabledState] = useState(false)
  const [collectListShow, setCollectListShow] = useState(false)
  const [transferInOrderNoSet, setTransferInOrderNoSet] = useState('')
  const [transferOutCodeSet, setTransferOutCodeSet] = useState('')
  const [collectList, setCollectList] = useState([] as any[]);
  const reqMeg = '不能为空'
  useEffect(() => {
    initFn()
  }, [])
  useImperativeHandle(ref, () => ({
    validateFields: () => formRef.current?.onFormRef()?.validateFields(),
  }));
  const initFn = async () => {
    if(editData?.id){

    }else{
      formRef.current?.onFormRef()?.setFieldsValue({
        orderNo: editData?.orderNo,
        transferType: 'refundTransferFromBill',
      })
    }
  }
  const getOptions = async () => {
    setSpinning(true)
    //交易类型
    const transactionFeeTypeLists: any = await httpDictServTenant({
      parentKey: 'transactionFeeType',
      enabled: 1,
    })
    setSpinning(false)
    return Promise.resolve({
      creditFlagList: [{value: 'refundTransferFromBill', label: '按单据余额转出'}, {value: 'refundTransferFromAccount', label: '按订单余额转出'}],
      transactionTypeList: transactionFeeTypeLists,
    })
  }
  const receivableConfig = {
    searchMode:"group",
    rowSelectionType: 'radio',
    size: 'small',
    pagination: false,
    columns: [
      {
        title: '收款单号',
        dataIndex: 'transactionCode',
        width: 180,
      },
      {
        title: '支付方式',
        dataIndex: 'paymentMethodName',
        width: 100
      },
      {
        title: '收款金额',
        dataIndex: 'amount',
        width: 120
      },
      {
        title: '已核销金额',
        dataIndex: 'verifiedAmount',
        width: 130
      },
      {
        title: '未核销金额',
        dataIndex: 'unverifiedAmount',
        width: 130
      },
      {
        title: '收款账户',
        dataIndex: 'cardNo',
        width: 180
      },
      {
        title: '付款账户',
        dataIndex: 'paymentAccount',
        width: 180
      },
    ],
    // search: [
    //   {
    //     name: 'orderNoPrefix',
    //     label: '收款单号',
    //     placeholder: '收款单号',
    //   },
    // ],
  }
  const config = {
    searchMode:"group",
    rowSelectionType: 'radio',
    size: 'small',
    columns: [
      {
        title: '转入订单号',
        dataIndex: 'orderNo',
        width: 180,
      },
      {
        title: '客户姓名',
        dataIndex: 'customerName',
        width: 100,
        ellipsis: {
          showTitle: true,
        }
      },
      {
        title: '服务地址',
        dataIndex: 'serviceAddressName',
        width: 150,
        ellipsis: {
          showTitle: true,
        }
      },
      {
        title: '客户电话',
        dataIndex: 'customerPhone',
        width: 120
      },
      {
        title: '需求类型',
        dataIndex: 'bizTagName',
        width: 100
      },
      {
        title: '订单状态',
        dataIndex: 'orderStatusName',
        width: 100
      },
      {
        title: '应收金额合计',
        dataIndex: 'receivableAmount',
        width: 130
      },
      {
        title: '应收余额合计',
        dataIndex: 'unReceiveAmount',
        width: 130
      },
    ],
    search: [
      {
        name: 'customerName',
        label: '客户姓名',
        placeholder: '客户姓名',
      },
      {
        name: 'orderNoPrefix',
        label: '订单号',
        placeholder: '订单号',
      },
    ],
  };
  const getTableList = (values) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        // 不需要传该参数了，2025-3-7改的
        // query.customerId = editData?.customerId
        findResponseListByPage(current, pageSize, query).then((res)=>{
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    }); 
  };
  const getPaymentNumber = (values) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        // const { current, pageSize, query } = values
       let transactionType = formRef.current?.onFormRef()?.getFieldValue('transferOutTransactionType')
        transferListByRequest({
          orderId: editData?.orderId,
          transactionType
        }).then((res)=>{
          if(res.transactionJournalResponseList){
            setCollectList(res.transactionJournalResponseList || [])
            resolve({
              records: res.transactionJournalResponseList || [],
              total: res.transactionJournalResponseList.length || 0
            })
          }
        })
      } catch (e) {
        reject({ success: false });
      }
    }); 
  };
  const getSelectedRow = (v: any, selectedRows: any[]) => {
    if (selectedRows?.length > 0) {
      formRef.current?.onFormRef()?.setFieldsValue({
        transferInOrderId: selectedRows[0].orderId,
        transferInOrderNo: selectedRows[0].orderNo,
        serviceAddressName: selectedRows[0].serviceAddressName,
        customerName: selectedRows[0].customerName,
        customerPhone: selectedRows[0].customerPhone
      });
      setTransferInOrderNoSet(selectedRows[0].orderNo)
    }else{
      setTransferInOrderNoSet('')
      formRef.current?.onFormRef()?.setFieldsValue({
        transferInOrderId: '',
        transferInOrderNo: '',
        serviceAddressName: '',
        customerName: '',
        customerPhone: ''
      });
    }
  };
  
  const getPaymentNumberRow = (v: any, selectedRows: any[]) => {
    if (selectedRows?.length > 0) {
      formRef.current?.onFormRef()?.setFieldsValue({
        unverifiedAmount: selectedRows[0].unverifiedAmount,
        amount: selectedRows[0].amount,
        transferOutBillNo: selectedRows[0].transactionCode,
        transferOutCode: selectedRows[0].transactionCode,
      });
      setTransferOutCodeSet(selectedRows[0].transactionCode)
    }else{
      setTransferOutCodeSet('')
      formRef.current?.onFormRef()?.setFieldsValue({
        unverifiedAmount: '',
        amount: '',
        transferOutBillNo: '',
        transferOutCode: '',
      });
    }
  };
  const columns = [
    { title: '收款单号', dataIndex: 'transactionCode', width: 140, },
    { title: '支付方式', dataIndex: 'paymentMethodName', width: 120, },
    { title: '收款金额', dataIndex: 'amount', width: 140, },
    { title: '未核销金额', dataIndex: 'unverifiedAmount', width: 120, },
    // { title: '转出收款单号', dataIndex: 'unverifiedAmount', width: 120, },
    // { title: '转入收款单号', dataIndex: 'needVerifiedAmount', width: 140, },
  ];
  const getTransactionDetail = (item:any)=>{
    transferListByRequest({
      orderId: editData?.orderId,
      transactionType: item
    }).then((res)=>{
      console.log(res,'res')
      formRef.current?.onFormRef()?.setFieldsValue({
        canRefundAmount: res.canRefundAmount || 0,
      })
      if(res.transactionJournalResponseList){
        setCollectList(res.transactionJournalResponseList || [])
      }
    })
  }
  return (
    <Spin spinning={spinning}>
      <SGeneralForms
        ref={formRef}
        httpOptionsFn={getOptions}
        layout="vertical"
        configs={[
          {
            title: '转出信息',
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              // {
              //   label: '转款单号',
              //   name: 'transactionCode',
              //   isHideItem: !editData?.id,
              //   spanCol: 8,
              //   comConfig: {
              //     disabled: true
              //   },
              // },
              // {
              //   label: '转款时间',
              //   name: 'transactionCode',
              //   isHideItem: !editData?.id,
              //   // type: 'dateTime',
              //   spanCol: 8,
              //   comConfig: {
              //     disabled: true
              //   },
              // },
              {
                label: '转出交易类型',
                name: 'transferOutTransactionType',
                spanCol: 12,
                type: 'select',
                data: 'transactionTypeList',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'priKey', label: 'name' },
                  onChange: (value)=>{
                    // let form = formRef.current?.onFormRef()
                    // form.setFieldsValue({
                    //   transferType: 'refundTransferFromBill',
                    // })
                    getTransactionDetail(value)
                  }
                }
              },
              {
                label: '转出订单号',
                name: 'orderNo',
                spanCol: 12,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '订单可转余额',
                name: 'canRefundAmount',
                spanCol: 12,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '转出类型',
                name: 'transferType',
                spanCol: 12,
                // isDeps: true,
                // deps: [{ name: 'transferOutTransactionType', value: true }],
                type: 'radio',
                data: 'creditFlagList',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                    onChange: (value)=>{
                        // 切换的时候 置空
                        formRef.current?.onFormRef()?.setFieldsValue({
                          unverifiedAmount: '',
                          amount: '',
                        });
                        if(value.target.value === 'refundTransferFromAccount'){
                          setCollectListShow(true)
                        }else{
                          setCollectListShow(false)
                        }
                    }
                },
              },
              //按单据余额转出
              {
                label: '收款单号',
                name: 'transferOutCode',
                spanCol: 12,
                isDeps: true,
                deps: [{ name: 'transferType', value: 'refundTransferFromBill' }],
                required: true,
                rules: [{ required: true, message: reqMeg }],
                children:  (<SModalSelected
                    inputButtonLabel="选择"
                    selectType="table"
                    inputName="transactionCode"
                    config={receivableConfig}
                    defaultInputValue={transferOutCodeSet}
                    modalProps={{
                      width: 1000,
                      title: '请选择收款单',
                      cancelText: '取消',
                      okText: '确定',
                      destroyOnClose: true
                    }}
                    getTableList={getPaymentNumber}
                    onChange={getPaymentNumberRow}
                  />)
              },
              {
                label: '收款单号',
                name: 'transferOutBillNo',
                hidden: true
              },
              {
                label: '转出金额',
                name: 'transferOutAmount',
                spanCol: 12,
                isDeps: true,
                deps: [{ name: 'transferType', value: 'refundTransferFromBill' }],
                required: true,
                rules: [{ required: true, message: reqMeg }],
              },
              {
                label: '单据金额',
                name: 'amount',
                spanCol: 12,
                isDeps: true,
                deps: [{ name: 'transferType', value: 'refundTransferFromBill' }],
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '可转余额',
                name: 'unverifiedAmount',
                spanCol: 12,
                isDeps: true,
                deps: [{ name: 'transferType', value: 'refundTransferFromBill' }],
                comConfig: {
                  disabled: true
                },
              },
            ],
          },
          {
            title: '转入信息',
            formItem: [
              {
                label: '转入交易类型',
                name: 'transferInTransactionType',
                spanCol: 12,
                type: 'select',
                data: 'transactionTypeList',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'priKey', label: 'name' },
                }
              },
               {
                label: '转入订单号',
                name: 'transferInOrderNo',
                spanCol: 12,
                required: true,
                rules: [{ required: true, message: reqMeg }],
                children:  (<SModalSelected
                    inputButtonLabel="选择"
                    selectType="table"
                    inputName="orderNo"
                    config={config}
                    defaultInputValue={transferInOrderNoSet}
                    modalProps={{
                      width: 1000,
                      title: '请选择转入订单号',
                      cancelText: '取消',
                      okText: '确定',
                    }}
                    getTableList={getTableList}
                    onChange={getSelectedRow}
                  />)
              },
              {
                label: '转入订单号',
                name: 'transferInOrderId',
                hidden: true
              },
              {
                label: '客户姓名',
                name: 'customerName',
                spanCol: 12,
                comConfig: {
                  disabled: true
                }
              },
              {
                label: '客户电话',
                name: 'customerPhone',
                spanCol: 12,
                comConfig: {
                  disabled: true
                }
              },
              {
                label: '服务地址',
                name: 'serviceAddressName',
                spanCol: 12,
                comConfig: {
                  disabled: true
                }
              },
              {
                label: '原因说明',
                type: 'textarea',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                name: 'transferReason',
                spanCol: 24,
              },
            ]
          },
          //按订单余额转出
          {
            title: collectListShow ? '订单可转余额明细' : '',
            formItem: collectListShow ? [
              {
                name: 'receivedList',
                spanCol: 24,
                children: (
                  <Table
                    bordered
                    pagination={false}
                    columns={columns}
                    size="small"
                    dataSource={collectList} />
                )
              }
            ] : [] // 否则不渲染
          }
        ]}
      />
    </Spin>
  )
})
